import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-borrowing-facility',
  templateUrl: './borrowing-facility.component.html',
  styleUrls: ['./borrowing-facility.component.scss']
})
export class BorrowingFacilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
